import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss']
})
export class PatientDetailsComponent implements OnInit {
  patientInfo: any = {};
  clientInfo: any = {};
  medications: any = '';
  icdCodes: any;

  insuranceInfo: any = [];

  constructor(
    private dialogRef: MatDialogRef<PatientDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    this.getPatientinfo();
    this.getCaseOrderDrug();
    this.getPreviousCaseICDCodes();
    this.getInsuranceDetails();
  }

  getPatientinfo() {
    this.commonService.getPatientinfo(this.data.patientId).subscribe(res => {
      if (res) {
        this.patientInfo = res;
        this.getLabClient();
      }
    });
  }

  getLabClient() {
    this.commonService.getLabClient(this.patientInfo.labclientId).subscribe(res => {
      if (res) {
        this.clientInfo = res;
      }
    });
  }

  getCaseOrderDrug() {
    this.commonService.getCaseOrderDrug(this.data.patientId).subscribe(res => {
      if (res) {
        this.medications = res.map(m => m.drugName).join(',');
      }
    });
  }

  getPreviousCaseICDCodes() {
    this.commonService.getPreviousCaseICDCodes(this.data.patientId).subscribe(res => {
      if (res) {
        this.icdCodes = res;
      }
    });
  }

  getInsuranceDetails() {
    this.commonService.getInsuranceDetails(this.data.patientId).subscribe(res => {
      if (res && res.length > 0) {
        res.forEach(element => {
          element.viewInsuranceType = element.insuranceDetail.insuranceType;
          element.viewPolicyid = element.insuranceDetail.policyid;
          element.viewFullName = element.insuranceDetail.lastNameOfInsured + ', ' + element.insuranceDetail.firstNameOfInsured;
          element.viewGuarantorName = element.insuranceDetail.guarantorName;
          element.viewNoInsurance = (element.insuranceDetail.noInsurance ? 'Yes' : 'No');
        });
        this.insuranceInfo = res;
      }
    });
  }

  // applyFilter(filterValue: string) {
  //   this.insuranceInfo.filter = filterValue.trim().toLowerCase();
  //   if (this.insuranceInfo.paginator) {
  //     this.insuranceInfo.paginator.firstPage();
  //   }
  // }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
